export default "__VITE_ASSET__f0a6dbb3__"